import {
  FilterOptions,
  PatientSubRole,
  PrescriptionStatus,
  ProductTypeFileds,
  PromoCardProps,
  ReactSelectOptionProp,
  RouteMap,
  Step,
  Brand,
  SelectedFilters,
  SortOption,
} from '../interface/interface';
import homeIcon from '../assets/icons/home-icon.svg';
import medicinesIcon from '../assets/icons/medicines-icon.svg';
import shopIcon from '../assets/icons/shop-icon.svg';
import ordersIcon from '../assets/icons/orders-icon.svg';

import GeneralHealth from '/category/01-general-health-wellbeing.svg';
import EmotionalHealth from '/category/02-emotional-cognitive-wellbeing.svg';
import WomenHealth from '/category/03-womens-health-wellbeing.svg';
import MenHealth from '/category/04-mens-health-wellbeing.svg';
import ChildrenHealth from '/category/05-childrens-health-wellbeing.svg';
import TargetedHealth from '/category/06-treatment-targeted-care.svg';
import DailyCare from '/category/07-daily-care-hygiene.svg';
import NaturalBeauty from '/category/08-natural-beauty-skin-care.svg';
import EssentialOils from '/category/09-essential-oils-oils.svg';
import Sports from '/category/10-sport-fitness-nutrition.svg';
import PetCare from '/category/11-pet-care.svg';
import EcoFriendly from '/category/12-eco-friendly-cleaning.svg';

import AushBushFlower from '/brands/australian-bush-flower-essences.png';
import BioCeuticals from '/brands/bioceuticals-logo.png';
import Bioglan from '/brands/bioglan.png';
import HerbsOfGold from '/brands/herbs-of-gold.png';
import LifeCykel from '/brands/lifecykel.png';
import Metagenics from '/brands/metagenics.png';
import NoosaBasics from '/brands/noosa-basics.png';
import BareFoot from '/brands/barefoot-skincare-co-logo.png';
import EthicalNutrients from '/brands/ethical-nutrients.svg';
import KiwiHerb from '/brands/KIWIHERB Green Leaf Logo.png';
import ThrusdayImplantation from '/brands/Thursday-plantation.png';
import TrueProtein from '/brands/true-protien.svg';
import { StylesConfig } from 'react-select';

export const route: RouteMap = {
  Admin: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'patients',
      href: '/patients',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'tokens',
      href: '/tokens',
      current: false,
      mobileNavIcon: shopIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'tokens',
    },
    {
      name: 'orders',
      href: '/admin/orders',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'orders',
    },
    {
      name: 'products',
      href: '/products',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'products',
    },
    {
      name: 'roles',
      href: 'javascript:void(0);',
      subNav: [
        { name: 'Internal User', href: '/internal-user', current: false },
        { name: 'Doctors', href: '/doctors', current: true },
        { name: 'Clinics', href: '/clinics', current: true },
      ],
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'new user',
    },
  ],

  Patients: [
    {
      name: 'Home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: true,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'My Care Hub',
      href: 'javascript:void(0);',
      subNav: [
        {
          name: 'medication information',
          href: '/prescriptions',
          current: false,
        },
        {
          name: 'dosing diaries',
          href: '/dosage-diary',
          current: false,
          specificAccessRole: PatientSubRole.InternalPatient,
        },
        { name: 'monthly limits', href: '/monthly-limit', current: false },
        { name: 'order history', href: '/orders', current: false },
      ],
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: true,
      mobileOnlyHide: false,
      mobileName: 'My Care Hub',
    },
    {
      name: 'Shop non-script',
      href: '/non-script-range',
      current: false,
      mobileNavIcon: shopIcon,
      mobileOnly: true,
      mobileOnlyHide: false,
      mobileName: 'shop',
    },
  ],

  Dispense_Tech: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: true,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'orders',
      href: '/admin/orders',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'orders',
    },
    {
      name: 'patients',
      href: '/patients',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'tokens',
      href: '/tokens',
      current: false,
      mobileNavIcon: shopIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'tokens',
    },
    {
      name: 'products',
      href: '/products',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'products',
    },
  ],

  PLO: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'orders',
      href: '/admin/orders',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'orders',
    },
    {
      name: 'patients',
      href: '/patients',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'tokens',
      href: '/tokens',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'tokens',
    },
    {
      name: 'products',
      href: '/products',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'products',
    },
  ],

  Pharmacist: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'patients',
      href: '/patients',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'tokens',
      href: '/tokens',
      current: false,
      mobileNavIcon: shopIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'tokens',
    },
    {
      name: 'orders',
      href: '/admin/orders',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'orders',
    },
    {
      name: 'products',
      href: '/products',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'products',
    },
  ],
  Doctors: [
    {
      name: 'home',
      href: '/home',
      current: true,
      mobileNavIcon: homeIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'home',
    },
    {
      name: 'patients',
      href: '/patient/list',
      current: false,
      mobileNavIcon: medicinesIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'patients',
    },
    {
      name: 'resource hub',
      href: '/resource-hub',
      current: false,
      mobileNavIcon: ordersIcon,
      mobileOnly: false,
      mobileOnlyHide: false,
      mobileName: 'resource hub',
    },
  ],
};

export const statuses = {
  Active: 'text-green-700 bg-green-50 ring-green-600/20',
  Expired: 'text-red-700 bg-red-50 ring-red-600/10',
  Withdraw: 'text-gray-600 bg-gray-50 ring-gray-500/10',
};

export const australianStates = [
  'Select',
  'New South Wales',
  'Victoria',
  'Queensland',
  'Tasmania',
  'South Australia',
  'Western Australia',
  'Northern Territory',
  'Australian Capital Territory',
];

export const publicUrls = [
  '/login',
  '/logout',
  '/reset-password',
  '/register',
  '/reset-password-mail',
  '/guest/shop',
  '/guest/cart',
  '/guest/product',
  '/guest/search/products-list',
  '/guest/shop-non-script',
];

export const title: ReactSelectOptionProp[] = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Mx', value: 'Mx' },
];

export const genders: ReactSelectOptionProp[] = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Non-binary', value: 'non-binary' },
  { label: 'Gender-diverse', value: 'gender-diverse' },
  { label: 'Transgender', value: 'transgender' },
  { label: 'Different-identity', value: 'different-identity' },
  { label: 'Other', value: 'other' },
  { label: 'Unknown', value: 'unknown' },
];

export const roles: ReactSelectOptionProp[] = [
  { label: 'Admin', value: 'Admin' },
  { label: 'PLO (Patient Liaison Officer)', value: 'PLO' },
  { label: 'Dispense Tech', value: 'Dispense_Tech' },
  { label: 'Pharmacist', value: 'Pharmacist' },
];

export const addressTypeInter: ReactSelectOptionProp[] = [
  { label: 'Residential', value: 'residential' },
  { label: 'Business', value: 'business' },
  { label: 'Po', value: 'po' },
  { label: 'Other', value: 'other' },
  { label: 'Postal', value: 'postal' },
];

export const prescriptionStatus: ReactSelectOptionProp[] = [
  { label: 'Active', value: 'active' },
  { label: 'Ceased', value: 'ceased' },
  { label: 'Cancelled', value: 'cancelled' },
];

export const filterPrescriptionStatus: ReactSelectOptionProp[] = [
  { label: 'Active', value: PrescriptionStatus.Active },
  { label: 'Dispensed', value: PrescriptionStatus.Dispensed },
  { label: 'Ceased', value: PrescriptionStatus.Ceased },
  { label: 'Cancelled', value: PrescriptionStatus.Cancelled },
  // { label: 'Completed', value: 'completed' },
  { label: 'Expired', value: PrescriptionStatus.Expired },
  { label: 'Stopped', value: PrescriptionStatus.Stopped },
];

export const prescrriptionStatusList: ReactSelectOptionProp[] = [
  { label: 'Active', value: 'active' },
  { label: 'Ceased', value: 'ceased' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Available', value: 'available' },
  { label: 'Exhausted', value: 'exhausted' },
  { label: 'Duplicate', value: 'duplicate' },
  { label: 'Expired', value: 'expired' },
  { label: 'Legacy', value: 'legacy' },
  { label: 'Completed', value: 'completed' },
  { label: 'Dispensed', value: 'dispensed' },
  { label: 'Disabled', value: 'disabled' },
];

export const InternalButNotAdmin = ['Dispense_Tech', 'PLO', 'Pharmacist'];

export const productStatusList: ReactSelectOptionProp[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const activeOrInActiveList: ReactSelectOptionProp[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const onboardedOrInvitedList: ReactSelectOptionProp[] = [
  { label: 'All Active', value: 'active' },
  { label: 'Invited', value: 'invited' },
  { label: 'Onboarded', value: 'onboarded' },
  { label: 'Not Onboarded', value: 'notOnboarded' },
  { label: 'Not Invited', value: 'notInvited' },
];

export const orderProductStatus = [
  { id: 0, name: 'Invalid', active: true, color_code: '#C12026' },
  { id: 1, name: 'Ordered', active: true, color_code: '#7989C2' },
  { id: 2, name: 'Dispensing', active: true, color_code: '#F3C6BA' },
  { id: 3, name: 'Ready for scan', active: true, color_code: '#F3F6FB' },
  { id: 4, name: 'Ready for shipping', active: true, color_code: '#BCC4E1' },
  { id: 5, name: 'Shipped', active: true, color_code: '#E39FC3' },
  { id: 6, name: 'Cancelled', active: true, color_code: '#9A1A1E' },
  { id: 7, name: 'Cancellation request', active: true, color_code: '#C5A2A4' },
  { id: 8, name: 'Paused', active: true, color_code: '#FEF2F3' },
];

export const specialCharacterRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

export const upperCaseRegex = /[A-Z]/;

export const numberCaseRegex = /[0-9]/;

export const productDefaultColors = [
  '#586CB3',
  '#DA7FAF',
  '#2CB57F',
  '#E78D75',
  '#A74C7C',
  '#E39FC3',
  '#EDA997',
  '#7989C2',
  '#F2D171',
  '#4C6495',
  '#F3C6BA',
  '#239166',
  '#BCC4E1',
  '#EEC142',
  '#EDBFD7',
  '#D5F0E5',
  '#E17052',
  '#F6DFEB',
  '#9BA7D1',
];

export const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*\W)(?!.*\s).{8,}$/;

export const renderStatusColor = (status: string, bg = true) => {
  switch (status) {
    case PrescriptionStatus.Active:
      if (bg) {
        return 'bg-secondary-green-100';
      }
      return 'bg-secondary-green-600';

    case PrescriptionStatus.Completed:
      if (bg) {
        return 'bg-secondary-green-100';
      }
      return 'bg-secondary-green-600';

    default:
      if (bg) {
        return 'bg-primary-red-100';
      }
      return 'bg-primary-red-600';
  }
};

export const filterByOptions = [
  { label: 'Date Type', value: '' },
  { label: 'Ordered Date', value: FilterOptions.CreatedDate },
  { label: 'Last Edited', value: FilterOptions.UpdatedDate },
];

export const userType = [
  { label: 'Internal', value: true },
  { label: 'External', value: false },
];

export const states = [
  { id: 1, name: 'New South Wales', abbriviation: 'NSW', country: { id: 1 } },
  { id: 2, name: 'Victoria', abbriviation: 'VIC', country: { id: 1 } },
  { id: 3, name: 'Queensland', abbriviation: 'QLD', country: { id: 1 } },
  { id: 4, name: 'Tasmania', abbriviation: 'TAS', country: { id: 1 } },
  { id: 5, name: 'South Australia', abbriviation: 'SA', country: { id: 1 } },
  { id: 6, name: 'Western Australia', abbriviation: 'WA', country: { id: 1 } },
  { id: 7, name: 'Northern Territory', abbriviation: 'NT', country: { id: 1 } },
  {
    id: 8,
    name: 'Australian Capital Territory',
    abbriviation: 'ACT',
    country: { id: 1 },
  },
];

export const creditCardProducts = [
  'Card Surcharge',
  'Credit Card Processing Fee',
];

export const surchargeLineItemTitles = [
  ...creditCardProducts,
  'Card Surcharge v2',
  'Dispensing & Fulfilment Fee',
];

export enum Messages {
  NON_ACTIVE_PRESCRIPTION_IN_CART = `The product prescription is invalid as it is no longer in active status. Please consider removing 
  the product or clearing the cart.`,
}

export const OutOfStockMessages = {
  QuantityZero: 'Out of Stock – Substitute Available.',
  OrderQuantityExceeds: (inventoryQuantity: number) =>
    `Product is almost out of stock, only ${inventoryQuantity} quantity available. 
     You can shop ${inventoryQuantity} or please contact our team for assistance on 1800 123 687.`,
  NoSubs: `Out of Stock.
  Please contact our team for assistance on 1800 123 687.`,
  NoDoctorApprovedSub:
    'Out of Stock, with no doctor approved substitutions. Please contact our team at 1800 123 687',
  OrderQuantitesExceededWithNoSubs: (
    inventoryQuantity: number,
  ) => `Product is Out of Stock, only ${inventoryQuantity} quantities available. You can shop ${inventoryQuantity} or
              Please contact our team for assistance 1800 123 687.`,
};

export const AusPostMax40Limit = 40;

export const AuspostTrackingURL = 'https://auspost.com.au/mypost/track/details';

export const ProductTypeLabelMapping = {
  [ProductTypeFileds.SCRIPT_RANGE]: 'Script Range',
  [ProductTypeFileds.NON_SCRIPT_RANGE]: 'Non Script Range',
  [ProductTypeFileds.DEVICEANDACCESSORIES]: 'Devices & Accessories',
  [ProductTypeFileds.BUNDLES]: 'Bundles',
};

export const patientUserTypeList: ReactSelectOptionProp[] = [
  { label: 'Patient', value: 'Patient' },
  { label: 'Prescription', value: 'Prescription' },
];

export const PatientTypeProps: ReactSelectOptionProp[] = [
  { label: 'External', value: 'external' },
  { label: 'Internal', value: 'internal' },
];

export const PatientStatusProps: ReactSelectOptionProp[] = [
  { label: 'Active', value: 'active' },
  { label: 'InActive', value: 'inactive' },
];

export const RegisteredFilterProps: ReactSelectOptionProp[] = [
  { label: 'On', value: 'ON' },
  { label: 'Before', value: 'BEFORE' },
  { label: 'After', value: 'AFTER' },
  { label: 'Between', value: 'BETWEEN' },
];

export const steps: Step[] = [
  {
    id: 0,
    name: 'Select User Type and Email Template',
  },
  {
    id: 1,
    name: 'Select details',
  },
  {
    id: 2,
    name: 'Preview',
  },
];
export const SHOW_CUSTOMER_BANNER = true;

export const RemovedProductsCategory = [
  'CBD Capsules',
  'CBD Oil',
  'Grinder',
  'Softgel Capsules',
  'Wafers',
];

export const PrescriptionProps: ReactSelectOptionProp[] = [
  { label: 'Available', value: 'available' },
  { label: 'Active', value: 'active' },
  { label: 'InActivate', value: 'inactive' },
  { label: 'Exhausted', value: 'exhausted' },
  { label: 'Duplicate', value: 'duplicate' },
  { label: 'Ceased', value: 'ceased' },
  { label: 'Expired', value: 'expired' },
  { label: 'Legacy', value: 'legacy' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Completed', value: 'completed' },
  { label: 'Dispensed', value: 'dispensed' },
  { label: 'Disabled', value: 'disabled' },
  { label: 'Stopped', value: 'stopped' },
];

export const excludedProductListForPermissableProducts = [
  'Vapormed Mighty+ Medic Dry Herb Vaporiser',
  'Vapormed Mighty Medic',
  'Grenco Medical Elite II Dry Herb Vaporiser',
];

export enum CartModalStorageKeys {
  PermanentlyDismissed = 'CART_MODAL_PERMANENTLY_DISMISSED',
  TemporarilyDismissed = 'CART_MODAL_TEMPORARILY_DISMISSED',
}

export const productNameToExclude = [
  'Card Surcharge',
  'Credit Card',
  'Card Surcharge v2',
  'Dispensing & Fulfilment Fee',
];

export enum ProductBrands {
  ATLUS = 'Atlus',
}

export const DoctorTypeProps: ReactSelectOptionProp[] = [
  { label: 'All', value: 'all' },
  { label: 'Internal', value: 'internal' },
  { label: 'External', value: 'external' },
];

export enum Pharmacy {
  MEDRELEAF = 'MedReleaf',
}

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 3;
export const ZOOM_STEP = 0.2;
export const APP_STORE_URL =
  'https://apps.apple.com/au/app/monivea-road/id6756564513';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.monivearoad';

export const FILE_LIMITS = {
  pdf: {
    mimeTypes: ['application/pdf'],
    maxSize: 5 * 1024 * 1024,
  },
  video: {
    mimeTypes: ['video/mp4', 'video/mkv', 'video/avi', 'video/mov'],
    maxSize: 70 * 1024 * 1024,
  },
};

export enum NOTIFICATION_MODE {
  BULK = 'bulk',
  SINGLE = 'single',
}

export const Alphabets = [
  '#',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export enum RespMessages {
  EMAILINVALID = 'Email is invalid',
}

export const PrimaryCategories = [
  {
    category: 'General Health & Wellbeing',
    image: GeneralHealth,
  },
  {
    category: 'Emotional & Cognitive Wellbeing',
    image: EmotionalHealth,
  },
  {
    category: 'Women’s Health & Wellbeing',
    image: WomenHealth,
  },
  {
    category: 'Men’s Health & Wellbeing',
    image: MenHealth,
  },
  {
    category: 'Children’s Health & Wellbeing',
    image: ChildrenHealth,
  },
  {
    category: 'Treatment & Targeted Care',
    image: TargetedHealth,
  },
  {
    category: 'Daily Care & Hygiene',
    image: DailyCare,
  },
  {
    category: 'Natural Beauty & Skin Care',
    image: NaturalBeauty,
  },
  {
    category: 'Essential Oils',
    image: EssentialOils,
  },
  {
    category: 'Sport & Fitness Nutrition',
    image: Sports,
  },
  {
    category: 'Pet Care',
    image: PetCare,
  },
  {
    category: 'Eco Friendly Cleaning',
    image: EcoFriendly,
  },
];

export const ListOfBrands = [
  {
    brand: 'Australian Bush Flower Essences',
    image: AushBushFlower,
  },
  {
    brand: 'BioCeuticals',
    image: BioCeuticals,
  },
  {
    brand: 'Bioglan',
    image: Bioglan,
  },
  {
    brand: 'Herbs of Gold',
    image: HerbsOfGold,
  },
  {
    brand: 'Life Cykel',
    image: LifeCykel,
  },
  {
    brand: 'Metagenics',
    image: Metagenics,
  },
  {
    brand: 'Noosa Basics',
    image: NoosaBasics,
  },
  {
    brand: 'Barefoot SkinCare',
    image: BareFoot,
  },
  {
    brand: 'KiwiHerb',
    image: KiwiHerb,
  },
  {
    brand: 'Ethical Nutrients',
    image: EthicalNutrients,
  },
  {
    brand: 'Thursday Plantation',
    image: ThrusdayImplantation,
  },
  {
    brand: 'TRUE Protein',
    image: TrueProtein,
  },
];
export const Naturopath_url =
  'https://outlook.office.com/book/MoniveaRoadNaturopath@atlus.com.au/s/ugdsWAyrJE6C_GYAQrOhXQ2?ismsaljsauthenabled';

export const DEFAULT_AUTOPLAY_INTERVAL = 6000;
export const SWIPE_THRESHOLD_PX = 50;

export const DESKTOP_ARROW_BASE_CLASSNAME = `absolute top-1/2 z-20 hidden -translate-y-1/2 items-center
    justify-center rounded-full bg-white/90 p-2 text-primary-blue-500 shadow-md transition
    hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
    focus-visible:outline-primary-blue-500 md:flex`;

export const MOBILE_ARROW_BUTTON_CLASSNAME = `flex items-center justify-center rounded-full bg-white p-2
    text-primary-blue-500 shadow-md focus-visible:outline focus-visible:outline-2
    focus-visible:outline-offset-2 focus-visible:outline-primary-blue-500`;

export const CTA_BUTTON_CLASSNAME = `inline-flex w-fit items-center justify-center rounded-full
      bg-primary-blue-500 px-6 py-3 text-xs font-semibold uppercase tracking-wide
      text-white transition-colors duration-200 hover:bg-primary-blue-600
      focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
      focus-visible:outline-primary-blue-500 sm:text-sm`;

export const VARIANT_STYLES: Record<
  NonNullable<PromoCardProps['variant']>,
  { background: string; eyebrow: string }
> = {
  cool: {
    background: 'bg-secondary-cornflowerblue-50',
    eyebrow: 'text-secondary-green-600',
  },
  warm: {
    background: 'bg-primary-yellow-50',
    eyebrow: 'text-secondary-tangerine-600',
  },
};

export const CARD_CLASSNAME = `flex h-20 w-[150px] shrink-0 items-center justify-center
  rounded-lg border border-grey-200 bg-white p-3 shadow-sm transition-all duration-200
  md:h-24 md:w-[180px] xl:w-[210px]`;

export const customerCare = [
  {
    name: 'Frequently Asked Questions',
    url: 'https://monivearoad.com.au/faqs/',
  },
  {
    name: 'Terms and Conditions',
    url: 'https://monivearoad.com.au/terms-of-service/',
  },
  {
    name: 'Privacy Policy',
    url: 'https://monivearoad.com.au/patient-privacy-policy/',
  },
];

export const brands: Brand[] = [
  {
    id: 'australian-bush-flower-essences',
    name: 'Australian Bush Flower Essences',
    imageUrl: '/brands/australian-bush-flower-essences.png',
    href: '/brands/australian-bush-flower-essences',
  },
  {
    id: 'bioceuticals',
    name: 'BioCeuticals',
    imageUrl: '/brands/bioceuticals-logo.png',
    href: '/brands/bioceuticals',
  },
  {
    id: 'metagenics',
    name: 'Metagenics',
    imageUrl: '/brands/metagenics.png',
    href: '/brands/metagenics',
  },
  {
    id: 'bioglan',
    name: 'Bioglan',
    imageUrl: '/brands/bioglan.png',
    href: '/brands/bioglan',
  },
  {
    id: 'herbs-of-gold',
    name: 'Herbs of Gold',
    imageUrl: '/brands/herbs-of-gold.png',
    href: '/brands/herbs-of-gold',
  },
  {
    id: 'lifecykel',
    name: 'Life Cykel',
    imageUrl: '/brands/lifecykel.png',
    href: '/brands/lifecykel',
  },
  {
    id: 'noosa-basics',
    name: 'Noosa Basics',
    imageUrl: '/brands/noosa-basics.png',
    href: '/brands/noosa-basics',
  },
  {
    id: 'bare-foot',
    name: 'Barefoot SkinCare',
    imageUrl: '/brands/barefoot-skincare-co-logo.png',
    href: '/brands/barefoot-skincare-co-logo.png',
  },
  {
    id: 'ethical-nutrients',
    name: 'Ethical Nutrients',
    imageUrl: '/brands/ethical-nutrients.svg',
    href: '/brands/ethical-nutrients.svg',
  },
  {
    id: 'kiwi-herb',
    name: 'KiwiHerb',
    imageUrl: '/brands/KIWIHERB Green Leaf Logo.png',
    href: '/brands/KIWIHERB Green Leaf Logo.png',
  },
  {
    id: 'thursday-implantation',
    name: 'Thursday Plantation',
    imageUrl: '/brands/Thursday-plantation.png',
    href: '/brands/Thursday-plantation.png',
  },
  {
    id: 'true-protien',
    name: 'TRUE Protein',
    imageUrl: '/brands/true-protien.svg',
    href: '/brands/true-protien.svg',
  },
];

export const CTA_BUTTON_CLASS = `inline-flex w-fit items-center justify-center rounded-full
  bg-primary-blue-500 px-6 py-3 text-xs font-semibold uppercase tracking-wide
  text-white transition-colors duration-200 hover:bg-primary-blue-600
  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
  focus-visible:outline-primary-blue-500 sm:text-sm`;

export const FEATURED_PRODUCTS_COUNT = 6;

export const HID_SCANNER_MAX_KEYSTROKE_GAP_MS = 50;
export const HID_SCANNER_MIN_BARCODE_LENGTH = 4;

export const CAMERA_SCAN_MISS_RESET_THRESHOLD = 5;

export const DISPENSING_AND_FULLFILLMENT_FEE = '3.50';

export const EMPTY_FILTERS: SelectedFilters = {
  primaryCategories: [],
  subCategories: [],
  tertiaryCategories: [],
  conditions: [],
  brands: [],
};

export const customStyles: StylesConfig<SortOption, false> = {
  control: (base, state) => ({
    ...base,
    borderRadius: '9999px',
    border: '1px solid #D2D5DA',
    boxShadow: state.isFocused
      ? '0 1px 6px rgba(0,0,0,0.12)'
      : '0 5px 6px rgba(0,0,0,0.08)',
    minHeight: '40px',
    paddingLeft: '8px',
    paddingRight: '4px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0 1px 6px rgba(0,0,0,0.12)',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 4px',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#1e3a8a',
    fontWeight: 600,
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#1e3a8a',
    fontWeight: 600,
    fontSize: '13px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: '#1e3a8a',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.2s ease',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    zIndex: 50,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#1e3a8a'
      : state.isFocused
        ? '#f3f4f6'
        : '#fff',
    color: state.isSelected ? '#fff' : '#1e293b',
    fontSize: '12px',
    cursor: 'pointer',
  }),
};

export const SORT_OPTIONS: SortOption[] = [
  { label: 'Price: Low to High', value: 'low-to-high' },
  { label: 'Price: High to Low', value: 'high-to-low' },
];

export const CATEGORY_KEY_SEPARATOR = '|';

export const SELECTED_CATEGORIES_KEY = 'selectedCategories';

export const NAV_ITEMS = ['Products', 'Brands'];

export const PROFILE_LIST = [
  { name: 'My Profile', href: '/profile' },
  { name: 'My Wishlist', href: '/product/wishList' },
  { name: 'Sign out', href: '/logout' },
];

export const PackagingSlipPrescribedProducts = [
  'Vape Yocan UNI Pro Portable Vaporizer (510 Thread)',
  'Vape Yocan UNI Pro Portable Vaporiser (510 Thread)',
  '510 Thread Magnetic Adapter',
];
